/* eslint-disable no-useless-catch */

import api from './base';
import axios from 'axios';

import { IFormData } from '@/components/Modals/FormModal';
import { IUser } from '../types/user';

export const getToken = async () => {
  try {
    const response = await api.get('/auth/csrf-token');
    return response.data;
  } catch (e: unknown) {
    throw e
  }
};

export const sendAuthRequest = async (data:FormData) => {
  try {
    const response = await api.post('/auth/login', data);
    return response;
  } catch (err:Error | unknown) {
    if (axios.isAxiosError(err)) {
      return err.response; // Возвращаем сам ответ с ошибкой, если он есть
    }
  }
};

export const sendLogoutRequest = async () => {
  try {
    const response = await api.get('/auth/logout');
    return response.data;
  } catch (e: unknown) {
    throw e
  }
};


export const checkAuthUser = async () =>  {
  try {
    const response = await api.get('/auth/user');
    return response;
  }
  catch (err: Error | unknown) {
    throw err;
  }
}

export const getClaims = async () => {
  try {
      const response = await api.get('/claims')
      return response.data;
  }
  catch (e: unknown) {
    throw e
  }
}

export const getStarted = async () => {
  try {
    const response = await api.get('/started');
    return response.data
  }
  catch (e: unknown) {
    throw e
  }
}

export const getCases = async () => {
  try {
    const response = await api.get('/cases');
    return response.data
  }
  catch (e: unknown) {
    throw e
  }
}

export const inviteMember = async (user: IUser) => {
  try {
    const response = await api.post('/invite-member', user);
    return response.data
  }
  catch (e: unknown) {
    throw e
  }
}

export const saveObjection = async (id: number, status: boolean) => {
  try {
    const response = await api.post(`/debt-collections/${id}/objection`, { params: { checked: status } });
    return response.data
  }
  catch (e: unknown) {
    throw e
  }
}

export const startReminder = async (debtorId: number) => {
  try {
    const response = await api.post(`/debtors/${debtorId}/start-reminder-process`);
    return response.data
  }
  catch (e: unknown) {
    throw e
  }
}

export const resumeCase = async (id: number) => {
  try {
    const response = await api.post(`/debt-collections/${id}/resume`);
    return response.data
  }
  catch (e: unknown) {
    throw e
  }
}

export const updateDebtor = async (debtorId: number, data: IFormData) => {
  try {
    const response = await api.patch(`/debtors/${debtorId}`, { ...data });
    return response.data
  }
  catch (e: unknown) {
    throw e
  }
}

export const getCompanies = async () => {
  try {
      const response = await api.get('/companies')
      return response.data;
  }
  catch (e: unknown) {
    throw e
  }
}

export const getCurrentCompany = async () => {
  try {
      const response = await api.get('/current-company')
      return response.data;
  }
  catch (e: unknown) {
    throw e
  }
}

export const setCompanyRequest = async (companyId: number) => {
  try {
      const response = await api.post('/set-company/' + companyId)
      return response.data;
  }
  catch (e: unknown) {
    throw e
  }
}

export const importState = async () => {
  try {
    const response = await api.get('/import-state');
    return response.data
  }
  catch (e: unknown) {
    throw e
  }
}

export const startImport = async () => {
  try {
    const response = await api.post(`/import`);
    return response.data
  }
  catch (e: unknown) {
    throw e
  }
}


export const getNotifications = async (page = 1) => {
  const response = await api.get("/notifications", { params: { page } });
  return response.data;
}

export const markNotificationAsRead = async (last_seen_id: number) => {
  await api.post('/notifications/read', { last_seen_id });
}

export const hideNotification = async (id: number) => {
  await api.post(`/notifications/${id}/hide`);
}

export const checkUnreadNotifications = async () => {
  const response = await api.get("/notifications/unread-count");
  return response.data;
}
